import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-expandable-table-row',
  templateUrl: './expandable-table-row.component.html',
  styleUrls: ['./expandable-table-row.component.scss'],
})

export class ExpandableTableRowComponent {
  @Input() columns: string[];
  @Input() rowData: any; 
  @Input() subRows: any[] = []; 

  expanded: boolean = false;
  constructor() {}

  toggleExpand() {
    this.expanded = !this.expanded; 
  }
}
